export function Alert({ children, type = "info", className }) {
  const colors = {
    info: "bg-blue-100 text-blue-800 border-blue-300",
    success: "bg-green-100 text-green-800 border-green-300",
    error: "bg-red-100 text-red-800 border-red-300",
    warning: "bg-yellow-100 text-yellow-800 border-yellow-300",
  };

  return (
    <div
      className={`border-l-4 p-4 rounded-lg ${colors[type] || colors.info} ${
        className || ""
      }`}
    >
      {children}
    </div>
  );
}

export function AlertDescription({ children, className }) {
  return <p className={`text-sm mt-1 ${className || ""}`}>{children}</p>;
}
